import { useState } from "react";
import { fetchAssistantChatGPT, fetchLLMStreaming } from "../services/chat.service";
import { useMutationAdapter } from "./useQueries";
import { useTranslator } from "./useTranslator";

export async function* generador(stream) {
    const reader = stream.getReader(); 
    const decoder = new TextDecoder(); 
    let done = false;
    let chunk = '';
    while (!done) {
      const { done: isDone, value } = await reader.read(); 
      done = isDone;
      if (value) {
        chunk += decoder.decode(value, { stream: true });
        yield chunk;
      }
    }
    reader.releaseLock(); // Libera el lock del lector cuando ya no sea necesario
  }

export const useLLM = ({stream=false,createBody,lastReq:_lastReq = null}) => {
        const { mutateAsync, isLoading,called } = useMutationAdapter(fetchAssistantChatGPT);
        const [lastReq,setLastReq] = useState(_lastReq);
        const { i18n,t } = useTranslator();
        const mutate = async (data) => {
            const payload = createBody(data,{i18n,t,lastRequest:lastReq});
            let res = await mutateAsync(payload)
                .catch(() => null);
            return {...payload,...res};
        }
        const mutateStream = async (data) => {
            const payload = createBody(data,{i18n,t,lastReq});
            let res = await fetchLLMStreaming(payload).catch(() => null);
            return {...payload,...res};
        }
        const send = async (data) => {
            const message = data.message;
            let res = null;
            if(!stream) {
                res = await mutate({ ...data, message });
                setLastReq(res);
                res = res?.messages?.[0]?.data;
            }
            else {
                res = await mutateStream({ ...data, message });
                setLastReq(res);
                res = {role: 'assistant',content: res};
            }
            return res;
        }
        return { send, isLoading,called,setLastRequest:setLastReq,lastRequest:lastReq };
}